export const serverUrl ={
    test:"https://test.alistetechnologies.com:8443",
    main:"https://subscriptioncloud.alistetechnologies.com",
    a3:"https://a3.alistetechnologies.com",
    aws:"https://subscriptioncloud.alistetechnologies.com",
    s:"https://int.alistetechnologies.com",
    pay:"https://web.alistetechnologies.com/payments/",
    partialPay:"https://web.alistetechnologies.com/payments/partial/",
}